var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.8361H14M11 2.83609C11.2652 2.57087 11.6249 2.42188 12 2.42188C12.1857 2.42188 12.3696 2.45845 12.5412 2.52953C12.7128 2.6006 12.8687 2.70477 13 2.83609C13.1313 2.96741 13.2355 3.12331 13.3066 3.29489C13.3776 3.46647 13.4142 3.65037 13.4142 3.83609C13.4142 4.02181 13.3776 4.2057 13.3066 4.37728C13.2355 4.54887 13.1313 4.70477 13 4.83609L4.66667 13.1694L2 13.8361L2.66667 11.1694L11 2.83609Z",
    stroke: "#150823",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColumn);
export default __webpack_public_path__ + "static/media/edit-column.932530f4228fd052d53fcba47f4e3b77.svg";
export { ForwardRef as ReactComponent };